import { NioApmPlus, } from '@nio-fe/nio-apm-plus';
import { type App, } from 'vue';
import { router, } from '@/router';
import { getEnv, isAlps, isFy, } from '@/utils/env';
import { getBrand, } from '@/utils/index';
import { ALPS_APM_ID, ALPS_APM_TOKEN, FY_APM_ID, FY_APM_TOKEN,ALPS_APM_SERVICE_NAME,FY_APM_SERVICE_NAME,NIO_APM_SERVICE_NAME } from '@/enums/configs';

// import { nioJsBridge, } from '@nio-wad/universal-bridge-h5';

export const setupAPM = async (app: App) => {
  console.log('import.meta.env.DEV', import.meta.env.DEV)
  if (import.meta.env.DEV) {
    // dev 环境下不开启监控
    return;
  }

  const env = getEnv();

  let serviceName = '';

  let apmToken = '', aid = 0;
  if(isAlps){
    apmToken = ALPS_APM_TOKEN
    aid = ALPS_APM_ID
    serviceName = ALPS_APM_SERVICE_NAME;
  }else if(isFy){
    aid = FY_APM_ID
    apmToken = FY_APM_TOKEN
    serviceName = FY_APM_SERVICE_NAME;
  }else{
    // nio
    aid = 0;
    apmToken = ''
    serviceName = NIO_APM_SERVICE_NAME;
  }
  let release = 
      process.env['FX_BUILD_VERSION']
      || process.env['LUBAN_CI_VERSION']
      || process.env['FX_OFFLINEPKG_VERSION']
      || process.env['BUILD_TIME']?.toString();

  await NioApmPlus.createDefaultInstance({
    aid: aid, // 必须换成自己申请的项目的aid
    token: apmToken,
    release, // 应用版本号，不用可以不传
    // SDK 默认填充 context 逻辑详见
    // https://nio.feishu.cn/docx/Ua72df3ElobAvpxSTU0cZ1hpnTd#doxcnKvkqhVeTEsz2SE5r33ANLb
    // 环境，不传走 SDK 默认填充 context 逻辑
    env,
    // 用户 id，不一定是数字 id，可以是 string，不传走 SDK 默认填充 context 逻辑
    // userId: account_id || nickName,
    // deviceId: 'xxx', // 设备 id，不传走 SDK 默认填充 context 逻辑
    plugins: {
      // pageview 插件具体配置可根据不同场景参考
      // https://nio.feishu.cn/docx/Ua72df3ElobAvpxSTU0cZ1hpnTd#doxcnXHuwWY3BVX6vdUBmIhpRmg
      pageview: {
        sendInit: false,
        routeMode: 'manual',
      },
      resourceError: false,
      performance: false,
      breadcrumb: false,
      // 具体使用方式参考
      // https://www.volcengine.com/docs/6431/104889#%E7%99%BD%E5%B1%8F%E6%8F%92%E4%BB%B6
      blankScreen: {
        // dom打分的根节点，支持querySelector语法。
        // 手动配置rootSelector为打分的根节点，准确定才更高。
        // 如果只想监控某个区域是否白屏，也可以配置为指定的区域节点。
        rootSelector: '#app',
        // dom打分的阈值。如果计算出来的分数小于阈值，则认为可能是白屏。
        // 该参数需针对不同应用配置合适的数值，避免白屏判断不准确。
        threshold: 1.5,
        // 是否自动上报当前页面的截屏图片。
        // 截屏一定程度上涉及安全隐私，但是能够帮助判定当前页面是否真的白屏。
        screenshot: false,
      },
      // vue 应用开启捕获 Vue.config.errorHandler
      // 如果初始化时无法获取 vue3 的 app 实例（或其他类似场景），
      // 可在初始化 SDK 之后
      // 通过 NioApmPlus.getDefaultInstance().addVueErrorHandlerPlugin 方法添加插件
      vueErrorHandler: {
        app, // const app = createApp(); vue 3 应用传这个
      },
    },
       // ── 新 Elastic APM 参数 ──
    serviceEnv: env, // 必传：枚举值 dev | test | stg | prod
    serviceName, // 必传：当前 FX 上的应用编码
    abTest: false, // 开启灰度，由北极星概率决定是否使用新 Elastic APM
  });

  router.afterEach((to) => {
    NioApmPlus.getDefaultInstance()?.sendPageView?.(to.name as string);
  });
};

export default setupAPM;
